import { CountryDetailPage } from "@/features/geolocation/page/CountryDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/country/$id/detail")({
  component: CountryDetailPage,
});
